import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

import { AbsenceDetailTooltipComponent } from './absence-detail-tooltip.component';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonsModule } from '@ui-kit/buttons/buttons.module';
import { LoaderModule } from '@ui-kit/loader/loader.module';
import { CommonPipesModule } from '@ui-kit/pipes/common-pipes.module';

@NgModule({
  declarations: [AbsenceDetailTooltipComponent],
  exports: [AbsenceDetailTooltipComponent],
  imports: [CommonModule, MatMenuModule, LoaderModule, CommonPipesModule, ButtonsModule, TranslateModule, MatTooltipModule]
})
export class AbsenceDetailTooltipModule {}
